module.exports = __webpack_public_path__ + "static/media/vf_mtshirts_core.0d6d9132.svg";